/* hp-localize-app-links.js — HIG-70 follow-up (Tobias 2026-06-06)
 *
 * Problem: metafields rendered by an APP block on the product page (the Variant
 * Description app — e.g. the "Set Components" list with links to the component
 * products) contain HARDCODED absolute links like
 * `https://highpowered.ch/products/…`. On the translated shops (/en/ /fr/ /it/)
 * those links drop the locale prefix and send the customer to the German shop.
 *
 * The theme's server-side `hp-localize-links` / `hp-localize-metafield` helpers
 * fix THEME-rendered content, but they can't touch app-rendered HTML (it's
 * injected by the app's own block at render time). So we localize those links
 * client-side: rewrite any internal highpowered.ch link inside a Shopify app
 * block to the current locale root (window.Shopify.routes.root).
 *
 * Generic by design — it fixes links in ANY app-block metafield, not just one
 * specific field, and re-runs whenever the app re-renders (variant change), so
 * future metafields that gain links are covered automatically.
 *
 * No-op on the German shop (root === '/'): the links are already correct there.
 */
(function () {
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (ROOT === '/') return; // German shop — links already point to the right place

  // Matches an absolute highpowered.ch URL and captures the path (incl. query/hash).
  var ABS = /^https?:\/\/(?:www\.)?highpowered\.ch(\/[^\s]*)?$/i;
  // Already-localized path (don't double-prefix).
  var HAS_LOCALE = /^\/(en|fr|it)\//i;

  function localizeOne(a) {
    var h = a.getAttribute('href');
    if (!h) return;
    var path = null;
    var m = h.match(ABS);
    if (m) {
      path = m[1] || '/';
    } else if (h.charAt(0) === '/' && h.charAt(1) !== '/') {
      // root-relative internal link (but not protocol-relative "//host")
      path = h;
    }
    if (path === null) return;
    if (HAS_LOCALE.test(path)) return; // already /en/ /fr/ /it/
    // ROOT already ends in '/'; strip the path's leading slash to avoid '//'.
    a.setAttribute('href', ROOT + path.replace(/^\//, ''));
  }

  function run() {
    var blocks = document.querySelectorAll('.shopify-app-block');
    for (var i = 0; i < blocks.length; i++) {
      var links = blocks[i].querySelectorAll('a[href]');
      for (var j = 0; j < links.length; j++) localizeOne(links[j]);
    }
  }

  function schedule() {
    // small delay so the app's DOM write settles before we read it
    window.setTimeout(run, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Re-run when the variant-description app (or the variant picker) re-renders.
  ['VariantDescriptionApp:change', 'vsk:variant:changed', 'variant:changed'].forEach(function (ev) {
    document.addEventListener(ev, schedule);
  });

  // Fallback: observe app blocks for async re-renders we don't get an event for.
  // Re-running is idempotent (already-localized hrefs are skipped), so the
  // observer can't loop — a localized href no longer matches ABS/unprefixed.
  if ('MutationObserver' in window) {
    var debounce = null;
    var obs = new MutationObserver(function () {
      window.clearTimeout(debounce);
      debounce = window.setTimeout(run, 80);
    });
    function observeBlocks() {
      document.querySelectorAll('.shopify-app-block').forEach(function (b) {
        obs.observe(b, { childList: true, subtree: true });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeBlocks);
    } else {
      observeBlocks();
    }
  }
})();
